export const getInitials = (firstName, lastName) => {
  const firstNameInitial = firstName ? firstName[0] : '';
  const lastNameInitial = lastName ? lastName[0] : '';

  return `${firstNameInitial}${lastNameInitial}`.trim().toUpperCase();
};
